<script>
  import { onMount } from "svelte"

  import { _ } from "svelte-i18n"

  import {
    message,
    fadeOutFlag,
    helpFlag,
    msgTimeouts,
    taxi,
  } from "../js/stores.js"

  import { changeMessage } from "../js/functions"

  let astronautState = "images/astronaut2.svg"

  $: astronautState = display ? "images/astronaut.svg" : "images/astronaut2.svg"

  let display = false
  $: if ($message === "") {
    display = false
  } else {
    display = false
    clearAllTimeouts()
    setTimeout(() => {
      display = true
    }, 100)
  }

  // $: console.log($msgTimeouts)

  function typewriter(node, { delay = 80 }) {
    const delayObj = {
      a: 170,
      b: 150,
      c: 120,
    }

    delay = delayObj[$taxi]
    // console.log(delay);

    const valid =
      node.childNodes.length === 1 &&
      node.childNodes[0].nodeType === Node.TEXT_NODE

    if (!valid) {
      throw new Error(
        `This transition only works on elements with a single text node child`
      )
    }

    const text = node.textContent
    const duration = text.length * delay

    return {
      duration,
      tick: (t) => {
        const i = ~~(text.length * t)
        node.textContent = text.slice(0, i)
      },
    }
  }

  function fadeOut() {
    // console.log("fade out in 1 sec")
    clearAllTimeouts()
    if ($fadeOutFlag) {
      $msgTimeouts.push(
        setTimeout(() => {
          display = false
          $message = ""
        }, 5000)
      )
      $msgTimeouts = $msgTimeouts
    }
  }

  function clearAllTimeouts() {
    $msgTimeouts.forEach((timeout) => {
      clearTimeout(timeout)
    })
    $msgTimeouts = []
  }

  onMount(() => {
    display = true
  })
</script>

<div id="astronautis-whole" class="astronautis-container">
  {#if display}
    <div id="msg" class="speech-bubble" in:typewriter on:introend={fadeOut}>
      {$message}
    </div>
    {#if !$fadeOutFlag}
      <div class="yes-no">
        <a
          href="#"
          role="button"
          style="margin-right: 10px;"
          on:click|preventDefault={() => {
            $helpFlag = true
            changeMessage("", false)
          }}
        >
          {$_("yes")}
        </a>
        <a
          href="#"
          role="button"
          on:click|preventDefault={() => {
            changeMessage("", false)
          }}
        >
          {$_("no")}
        </a>
      </div>
    {/if}
  {/if}

  <img src={astronautState} alt="" class="astronautis" />
</div>

<style>
  .astronautis-container {
    position: absolute;
    z-index: 200;
    bottom: 0px;
    right: 0px;

    display: flex;
    flex-direction: column;

    --bubble-bg-color: #ff7941;
  }

  .astronautis {
    width: 300px;
    margin-bottom: -200px;
  }
  .speech-bubble {
    position: absolute;
    bottom: 200px;
    right: 50px;
    background: var(--bubble-bg-color);
    border-radius: 30px;
    padding: 22px;
    width: 300px;
    margin-bottom: 30px;
    font-size: 1.3rem;
  }

  .speech-bubble:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 24px solid transparent;
    border-top-color: var(--bubble-bg-color);
    border-bottom: 0;
    border-right: 0;
    margin-left: -12px;
    margin-bottom: -24px;
  }

  .yes-no {
    background: var(--bubble-bg-color);
    border: 1px solid green;
    border-radius: 5px;
    padding: 10px;
    position: absolute;
    top: -40px;
    right: 40px;
    z-index: 200;
  }
  .yes-no a {
    color: white;
    text-decoration: none;
  }

  .yes-no a:hover {
    text-decoration: underline;
  }
  /*
  @media (min-width: 1000px) {

  } */

  @media (max-width: 600px) {
    .speech-bubble {
      width: 190px;
      bottom: 10px;
      right: 160px;
      padding: 12px;
      border-radius: 15px;
      font-size: 1rem;
    }
    .speech-bubble:after {
      left: 100%;
      right: 0;
      top: 50%;
      width: 0;
      height: 0;
      border: 25px solid transparent;
      border-left-color: var(--bubble-bg-color);
      border-right: 0;
      border-bottom: 0;
      margin-top: -12.5px;
      margin-right: -25px;
    }
    .astronautis {
      width: 150px;
      margin-bottom: -100px;
    }
  }
</style>
